import { render, staticRenderFns } from "./side-bar.vue?vue&type=template&id=6e243f5f&scoped=true&"
import script from "./side-bar.vue?vue&type=script&lang=js&"
export * from "./side-bar.vue?vue&type=script&lang=js&"
import style0 from "./side-bar.vue?vue&type=style&index=0&id=6e243f5f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e243f5f",
  null
  
)

export default component.exports